import { z } from 'zod';
import { PRESENTATION_VALIDATION } from '../constants';

export const getPresentationFormSchema = () => {
  return z.object({
    title: z
      .string()
      .min(PRESENTATION_VALIDATION.TITLE_MIN_LENGTH, 'Title is required')
      .max(
        PRESENTATION_VALIDATION.TITLE_MAX_LENGTH,
        `Title must be less than ${PRESENTATION_VALIDATION.TITLE_MAX_LENGTH} characters`
      ),
    description: z
      .string()
      .max(
        PRESENTATION_VALIDATION.DESCRIPTION_MAX_LENGTH,
        `Description must be less than ${PRESENTATION_VALIDATION.DESCRIPTION_MAX_LENGTH} characters`
      )
      .optional(),
    file: z
      .instanceof(File, { message: 'Please select a valid file' })
      .optional(),
  });
};

export const validatePresentationTitle = (
  value?: string
): string | undefined | boolean => {
  if (value === undefined) return false;

  const result = z
    .string()
    .min(PRESENTATION_VALIDATION.TITLE_MIN_LENGTH, 'Title is required')
    .max(
      PRESENTATION_VALIDATION.TITLE_MAX_LENGTH,
      `Title must be less than ${PRESENTATION_VALIDATION.TITLE_MAX_LENGTH} characters`
    )
    .safeParse(value);

  if (!result.success) {
    return result.error.issues[0].message;
  }

  return undefined;
};

export const validatePresentationDescription = (
  value?: string
): string | undefined | boolean => {
  if (value === undefined) return false;

  const result = z
    .string()
    .max(
      PRESENTATION_VALIDATION.DESCRIPTION_MAX_LENGTH,
      `Description must be less than ${PRESENTATION_VALIDATION.DESCRIPTION_MAX_LENGTH} characters`
    )
    .safeParse(value);

  if (!result.success) {
    return result.error.issues[0].message;
  }

  return undefined;
};

export const validatePresentationFile = (
  value?: File
): string | undefined | boolean => {
  if (value === undefined) return false;

  const result = z
    .instanceof(File, { message: 'Please select a valid file' })
    .safeParse(value);

  if (!result.success) {
    return result.error.issues[0].message;
  }

  return undefined;
};
